import { Component, OnInit, ViewChildren, QueryList, ViewChild, HostListener, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgForm } from '@angular/forms';
import { ObjectToSelect } from '../../../core/shared/objectToSelect.model';
import { DateInputModel } from '../../../core/shared/date-input/date-input.model';
import { RichTextComponent } from '../../../core/shared/richtext/richtext.component';
import { SelectionMode } from '../../../core/shared/grid/grid.model';
import { EmployeesListComponent } from '../../../company/employees/employee-list/employees-list.component';
import { GridComponent } from '../../../core/shared/grid/grid.component';
import { SpinEditComponent } from '../../../core/shared/spinedit/spinedit.component';
import { ProjectWatcher } from '../../../projects/projects.model';
import { ProjectsRest } from '../../../projects/projects.rest';
import { CustomersRest } from '../../../company/customers/customers.rest';
import { HasPermissions, Permissions } from '../../../core/services/permissions/permissions.model';
import { PermissionsService } from '../../../core/services/permissions/permissions.service';
import { Subscription } from 'rxjs';
import { INgxSelectOption } from 'ngx-select-ex';
import { LoginRest } from '../../../login/login.rest';
import { IssuesExtRest } from '../../issues-ext.rest';
import { Issue, IssueWatcher, IssueElement } from '../../../issues/issues.model';
import { DialogService } from '../../../core/shared/dialog/dialog.service';
import { DialogConfig } from '../../../core/shared/dialog/dialog-config';
import { ShellRestService } from '../../../shell/shell.rest';

@Component({
  selector: 'app-issue-ext-header',
  templateUrl: './issue-ext-header.component.html',
  styleUrls: []
})
export class IssueExtHeaderComponent implements OnInit, OnDestroy, HasPermissions {
  isCopy: boolean;
  constructor(private router: Router,
    private route: ActivatedRoute,
    private restExt: IssuesExtRest,
    public dialog: DialogService,
    private permissionService: PermissionsService,
    private loginRest: LoginRest,
    private shellRest: ShellRestService) {
      this.onResize();
    }

  public issueTypes: ObjectToSelect[];
  public employees: ObjectToSelect[];
  public departments: ObjectToSelect[];
  public systemVersions: ObjectToSelect[];
  public states: ObjectToSelect[];
  public projectSteps: ObjectToSelect[];
  public issue: Issue;
  public isNew: boolean;
  public startDate: DateInputModel;
  public isEditable: boolean;

  private descriptionView: RichTextComponent = null;
  private summerNoteHeight =  680;
  private subscription: Subscription;
  private oldProject: string;
  private oldCustomer: string;
  private currentUser: ObjectToSelect;  
  private notAssignedIssue: boolean;

  @ViewChildren(RichTextComponent) headerExtDescriptionViews: QueryList<RichTextComponent>;
  @ViewChild(GridComponent) watchersGrid: GridComponent;
  @ViewChild('issueFormExt') issueForm: NgForm;
  @ViewChild('priority') isPublic: SpinEditComponent;
  @ViewChild('planningWorkTime') planningWorkTime: SpinEditComponent;

  private watchersHeaders = [
    { displayName: 'Pracownik', propertyName: 'employeeFullName', propertyType: 'string' },
  ];
  permissions: Permissions;
  setPermissions(claimType: string): void {
    this.permissions = this.permissionService.getUserPermissions(claimType);
  }

  ngOnInit() {
    this.getIssueTypes();
   this.getDepartments();
   this.getStates();
    this.employees = new Array<ObjectToSelect>();
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  public setModel(issue: Issue, isNew: boolean, isCopy: boolean) {
    this.setPermissions('IssueExt');
    this.issue = issue;
    this.isNew = isNew;
    this.isCopy = isCopy ;

    this.shellRest.IsBlockedCustomer().subscribe((isBlockedCustomer: boolean) => {
      if (isBlockedCustomer)
        this.isEditable = false;
      else
        this.isEditable = isNew ? this.permissions.canAdd : this.permissions.canEdit;

      if (isNew) {     
        if(!this.isCopy){
          this.issue.projectName = '';
          this.issue.projectStepId = null;
          this.issue.projectStepName = '';
          this.issue.userStoryId = null;
          this.issue.userStoryName = '';
          this.issue.systemVersionId = null;
        }
        this.getCurrentUser(true);
      }
      this.setCustomerInfo();
      

      if (isNew) {
        if (!this.issue.issueType) {
          this.issue.issueType = this.issueTypes[0].name;
        }
        if (!this.issue.departmentId) {
          this.issue.departmentId = this.departments[0].id;
        }
        if (!this.issue.systemVersionId) {
          this.issue.systemVersionId = null;
        }
      }

      this.initializeDate();
      this.getDescription();

      if (this.issue.elementAssignee == null && !this.isNew) {
        this.notAssignedIssue = true;
      }
    });
  }

  private setCustomerInfo() {
    this.getSystemVersions(this.issue.customerId);
    this.getCustomerProjectSteps(this.issue.customerId);
    this.getCustomerEmployees(this.issue.customerId);
  }


  public getSystemVersions(customerId: number) {
    this.restExt.getSystemVersions(customerId).subscribe((result: ObjectToSelect[]) => {
      if (result) {
        this.systemVersions = result;
      }
    });
  }


  private initializeDate() {
    this.startDate = new DateInputModel();
    this.startDate.isReadOnly = true;
    this.startDate.isRequired = false;
    this.startDate.name = 'Data zgłoszenia';
    this.startDate.value = new Date(this.issue.startDate);
    this.startDate.valueStr = this.startDate.value.toDateString();
    this.startDate.withTime = false;
  }

  public saveDescription() {
    if (this.descriptionView == null) {
      return;
    }

    if (this.issue && typeof(this.descriptionView.getHtml()) === 'string' && this.descriptionView.getHtml() !== '') {
      this.issue.htmlDescripiton = this.descriptionView.getHtml();
    }
  }


  public getDescription() {
      if (!this.headerExtDescriptionViews) {
        return;
      }
      this.subscription = this.headerExtDescriptionViews.changes.subscribe((nv: QueryList<RichTextComponent>) => {
        if (this.descriptionView === null) {
          this.descriptionView = nv.first;
        }

        if (this.descriptionView && this.isNew && !this.issue.htmlDescripiton && this.issue.htmlDescripiton !== '') {
          this.descriptionView.setHtml('');
          this.issue.htmlDescripiton = '';
        } else if (!this.isNew) {
          this.descriptionView.setHtml(this.issue.htmlDescripiton);
        }

        if (!this.isEditable || this.issue.assigneeId ) {
          this.descriptionView.disableContol();
        }
      });

      if (!this.descriptionView) {
        if (this.headerExtDescriptionViews.first) {
          this.descriptionView = this.headerExtDescriptionViews.first;
          this.descriptionView.setHtml(this.issue.htmlDescripiton);
        }
      }
  }

  public addWatcher() {
    const dialogconf = new DialogConfig();
    dialogconf.title = 'Wybierz Obserwatorów';
    dialogconf.selectionMode = SelectionMode.multi;
    dialogconf.maxwidth = '1000px';
    dialogconf.data = {isFromExternalIssues: true, customerId: this.issue.customerId, customerCode: this.issue.customerCode};
    const ref = this.dialog.open(EmployeesListComponent, dialogconf);
    ref.afterClosed.subscribe(result => {
      if (result != null) {
        result.forEach(element => {
          const watcher = new IssueWatcher;
          watcher.issueId = this.issue.id;
          watcher.employeeFullName = element.fullName;
          watcher.employeeId = element.id;
          this.issue.issueWatchers.push(watcher);
        });
        this.watchersGrid.refreshData();
      }
    });
  }

  public getIssueTypes() {
    const action = this.restExt.getIssueTypes;
    action.call(this.restExt).subscribe((result: ObjectToSelect[]) => {
      if (result) {
        this.issueTypes = result;
      }
    });
  }

  public getDepartments() {
    const action = this.restExt.getDepartments;
    action.call(this.restExt).subscribe((result: ObjectToSelect[]) => {
      if (result) {
        this.departments = result;
      }
    });
  }
  
  public getStates() {    
    this.restExt.getStates(false).subscribe((result: ObjectToSelect[]) => {
      if (result) {
        this.states = result;
      }
    });
  }

  private removeWatcher(row: IssueWatcher) {
    if (row.id != null) {
      this.restExt.removeWatcher(row.id).subscribe();
    }
    this.issue.issueWatchers.splice(this.issue.issueWatchers.indexOf(row), 1);
    this.watchersGrid.refreshData();
  }

  @HostListener('window:resize', ['$event'])
  private onResize(event?) {
    if (window.innerWidth <= 650) {
      this.summerNoteHeight = 280;
    } else {
      this.summerNoteHeight = 430;
    }
  }
  public isInvalid() {
    return this.issueForm.invalid;
  }

  private tfsChanged() {
    if (this.issue.isToTfs) {
      this.issue.issueType = this.issueTypes.find(x => x.name === 'User Story').name;
    } else {
      this.issue.issueType = this.issueTypes.find(x => x.name === 'Zgłoszenie').name;
    }
  }

  private getCustomerProjectSteps(customerId: number) {
    this.restExt.getCustomerProjectStepsForIssue(customerId, this.issue.id).subscribe((result: ObjectToSelect[]) => {
      if (result) {
        this.projectSteps = result;
      }
    });
  }

  private setProjectStepName(event) {
    if (event[0]) {
      this.issue.projectStepName = event[0].data.name;
    }
  }

  private projectChanged() {
    this.issue.issueWatchers = this.issue.issueWatchers.filter((element) => {
      return element.isFromProject !== true;
    });
    this.watchersGrid.refreshData();
    if (this.issue.projectStepId == null) {
      return;
    }
    const action = this.restExt.getProjectWatchersByProjectStepId;
    action.call(this.restExt, this.issue.projectStepId).subscribe((result: ProjectWatcher[]) => {
        if (result) {
            result.forEach(element => {
              if (this.issue.issueWatchers.filter(x => x.employeeId === element.employeeId).length === 0) {
                  const watcher = Object.assign( new IssueWatcher(), {
                    employeeId: element.employeeId,
                    employeeFullName: element.projectWatcherName,
                    isFromProject: true
                });
                this.issue.issueWatchers.push(watcher);
                this.watchersGrid.refreshData();
              }
            });
        }
    });
  }

  private searchCallback(search: string, item: INgxSelectOption): boolean {
    search = search.toLowerCase();
    if (item.data) {
      return item.data.name.toLowerCase().includes(search) || item.data.guid.toLowerCase().includes(search);
    } else {
      return false;
    }
  }

  private getCustomerEmployees(customerId: number) {

    if (this.issue.assigneeId) {
      this.restExt.getCustomerEmployees(customerId,this.issue.assigneeId).subscribe((result: ObjectToSelect[]) => {
        if (result) {
            this.employees = result;
        }
      });
    }
    else {
      this.restExt.getCustomerEmployees(customerId,0).subscribe((result: ObjectToSelect[]) => {
        if (result) {
            this.employees = result;
        }
      });
    }
  }

  private getCurrentUser(withSetAssigneeAndReporter = false) {
    if (!this.currentUser) {
      this.loginRest.GetLoggedUser().subscribe((user: any) => {
        this.currentUser = new ObjectToSelect();
        this.currentUser.id = user.employeeId;
        this.currentUser.name = user.name;
        this.currentUser.guid = user.email;
        if (withSetAssigneeAndReporter) {
          this.setCurrentUserAsAssigneeAndReporter();
        }
      });
    } else {
      if (withSetAssigneeAndReporter) {
        this.setCurrentUserAsAssigneeAndReporter();
      }
    }
  }

  private setCurrentUserAsAssigneeAndReporter() {
    this.issue.reporterId = this.currentUser.id;
    if (this.employees.filter(x => x.id === this.currentUser.id).length === 0) {
      this.employees.push(this.currentUser);
    }
  }
}
